export default `
  mutation changeEnterprisePayer($enterpriseCustomerId: String!, $newPayerUserEmail: String!, $newPayerUserId: String) {
    changeEnterprisePayer(enterpriseCustomerId: $enterpriseCustomerId, newPayerUserEmail: $newPayerUserEmail, newPayerUserId: $newPayerUserId) {
      success
      message
    }
  }
`
